import type { FC } from "react"
import type { Control } from "react-hook-form"

import type { PurchaseOrderDialogFormValues, ShipToLocationWithWarehouse } from "../types"
import { getShipToLocationOptions } from "../utils/common"

import { FormSelect } from "@/components/UiKit/FormControls"

interface ShipToSelectProps {
  control: Control<PurchaseOrderDialogFormValues>
  shipToLocations: ShipToLocationWithWarehouse[]
  isFetching: boolean
  loadMore: () => void
}

export const ShipToSelect: FC<ShipToSelectProps> = ({ control, shipToLocations, isFetching, loadMore }) => (
  <FormSelect
    control={control}
    name='shipTo'
    label='Ship To'
    required
    placeholder='Select One'
    options={getShipToLocationOptions(shipToLocations)}
    loadMore={loadMore}
    fetching={isFetching}
  />
)
